import {
  withTranslation,
} from 'react-i18next';

import AdminGroupsPageView from './AdminGroupsPageView';

const TranslatedComponent = withTranslation()(AdminGroupsPageView);

const Component = TranslatedComponent;

export default Component;
